import React from 'react'
import { CustomDialogContent } from '..'

import { createStyles, makeStyles, Typography } from '@material-ui/core'

interface ITermsAndConditionsProps {
  onCloseTermsAndConditions: () => void
}

const useStyles = makeStyles(() =>
  createStyles({
    contentContainer: {
      lineHeight: 2,
      textAlign: 'justify',
      margin: '10px 0px',
    },
  })
)

export const TermsAndConditions = ({
  onCloseTermsAndConditions,
}: ITermsAndConditionsProps) => {
  const classes = useStyles()
  return (
    <CustomDialogContent
      title="Terms and Conditions"
      onCancel={onCloseTermsAndConditions}
    >
      <Typography variant="body1" className={classes.contentContainer}>
        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
        Lorem Ipsum has been the industrys standard dummy text ever since the 1500s,
        when an unknown printer took a galley of type and scrambled it to make a type
        specimen book.
      </Typography>

      <Typography variant="body1" className={classes.contentContainer}>
        Lorem Ipsum is simply dummy text of the printing and typesetting industry.
        Lorem Ipsum has been the industrys standard dummy text ever since the 1500s,
        when an unknown printer took a galley of type and scrambled it to make a type
        specimen book.
      </Typography>
    </CustomDialogContent>
  )
}
